export { default as ProductsTable } from './ProductsTable/ProductsTable'
export { default as ClientsTable } from './ClientsTable/ClientsTable'
export { default as ReceiptTable } from './Receipt/ReceiptTable'
export { default as InnerTable } from './InnerTable/InnerTable'
